import React, { useEffect, useState } from "react";
import { useDarkMode } from "../../context/DarkModeContext";

const DarkModeToggle: React.FC = () => {
    const { isDarkMode } = useDarkMode();
    const [ darkMode, setDarkMode ] = useState(isDarkMode);

    useEffect(() => {
        localStorage.setItem("darkMode", darkMode.toString());
        if (darkMode) {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    }, [ darkMode ]);

    const handleClick = () => setDarkMode(!darkMode);

    return (
        <button
            onClick={handleClick}
            className="
        p-2
        text-gray-600 dark:text-gray-400
        hover:text-gray-800 dark:hover:text-gray-200
        focus:outline-none focus:ring-0
        shadow-none
        transition-colors duration-300
      "
            aria-label="Toggle Dark Mode"
        >
            {darkMode ? (
                /* Simple Outline Moon Icon */
                <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 12.79A9 9 0 0111.21 3
               7 7 0 0021 12.79z"
                    />
                </svg>
            ) : (
                /* Simple Outline Sun Icon */
                <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 2v2m6.364
               1.636l-1.414 1.414M20
               12h-2m-1.636
               6.364l-1.414-1.414M12
               20v2m-4.95-3.636l-1.414
               1.414M4 12H2m3.636-4.95
               l-1.414-1.414M12
               8a4 4 0 100 8
               4 4 0 000-8z"
                    />
                </svg>
            )}
        </button>
    );
};

export default DarkModeToggle;
